import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { clsx, getCurrencySymbol } from "@/utils";
import { SignUpOperatorFormData } from "../types";

export const AverageTripCostField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const { currency } = useOperator();
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpOperatorFormData>();

  return (
    <div className={clsx("flex flex-row items-center gap-x-2", className)} {...props}>
      <div className="flex w-full flex-col">
        <Typography variant="paragraph">Average Trip Cost</Typography>
        <Typography variant="small" className="text-neutral-dark-gray">
          Best guestimate is sufficient. Enter amount in AUD ($).
        </Typography>
        <ErrorMessage errors={errors} name="averageTripCost" />
      </div>
      <TextInput
        className="w-[72px] flex-1"
        type="number"
        placeholder={`${getCurrencySymbol(currency)}0`}
        step="any"
        hasError={!!errors.averageTripCost}
        {...register("averageTripCost")}
      />
    </div>
  );
};
